// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminPortalAccess } from "./platform-admin-portal-access";
import { platformAdminPortalSecurity } from "./platform-admin-portal-security";
import { platformAdminPortalUiSemantics } from "./platform-admin-portal-ui-semantics";

export const platformAdminPortalManagement = {
  ...platformAdminPortalUiSemantics,
  ...platformAdminPortalSecurity,
  ...platformAdminPortalAccess,
  summaryVisible: "Visible",
  summaryEntries: "Entries",
  deleteGroupTitle: "Delete portal group",
  deleteGroupConfirm: 'Delete group "{name}"? You can only delete a group after it has no entries.',
  deleteGroupError: "This group still has {count} entries. Move them to another group first.",
  deleteGroupSuccess: "Portal group deleted",
  title: "Portal Management",
  subtitle:
    "Manage portal branding, entry orchestration, access settings, and security policies in one place.",
  appearanceTitle: "Portal Appearance",
  appearanceSubtitle: "Manage the portal logo, title, subtitle, and display copy.",
  appearanceNotice:
    "This page now manages the portal logo, title, subtitle, login copy, homepage welcome copy, and footer copy. Group titles belong in Portal Groups.",
  portalName: "Portal Name",
  portalSubtitle: "Portal Subtitle",
  loginTitle: "Login Title",
  loginSubtitle: "Login Description",
  homeWelcome: "Homepage Welcome Copy",
  footerText: "Footer Copy",
  logoLabel: "Logo",
  logoTitle: "Portal Logo",
  logoDescription:
    "After upload, the file is stored in the asset center branding space and synced to the portal display.",
  uploadLogo: "Upload Logo",
  replaceLogo: "Replace Logo",
  clearLogo: "Clear Logo",
  logoCleared: "Logo cleared",
  appearanceRestored: "Defaults restored",
  appearanceLogoUpdated: "Logo updated",
  entriesTitle: "Portal Entry Display",
  entriesSubtitle:
    "Manage portal display name, description, grouping, order, icon, and visibility. Standard service identity, domains, and ports come from the service endpoint registry.",
  groupsTitle: "Portal Groups",
  groupsSubtitle: "Manage portal groups (navigation folders) and their display order.",
  objects: {
    entry: "Portal Entry Display",
    group: "Portal Group",
  },
  groupsCreate: "Create Portal Group",
  groupsEditTitle: "Edit Portal Group · {name}",
  groupsEditTitleShort: "Edit Portal Group",
  groupsSaveSuccess: "Portal group updated",
  groupsCreateSuccess: "Portal group created",
  groupKey: "Group Key",
  groupName: "Group Name",
  groupLookup: "Find Portal Group",
  groupPickerTitle: "Find Portal Group",
  groupPickerApply: "Use Portal Group",
  groupPickerEmpty: "No portal groups available",
  groupPickerRequired: "Select a portal group first",
  groupDescription: "Group Description",
  groupStatus: "Group Status",
  groupSortOrder: "Group Order",
  entryName: "Portal Display Name",
  entryDescription: "Portal Display Description",
  entryGroup: "Portal Group",
  entrySortOrder: "Portal Order",
  entryDomain: "Entry Domain",
  entryAddress: "Entry Address",
  entryActions: "Portal Entry Actions",
  entryDetailTitle: "Portal Entry Detail · {name}",
  entryBasicTitle: "Portal Display Configuration",
  entryEnabled: "Portal Enabled",
  entryIconAppstore: "App",
  entryIconFolder: "Folder",
  entryIconRead: "Document",
  entryIconRocket: "Rocket",
  entryIconUser: "User",
  entryEditTitle: "Edit Entry Orchestration · {name}",
  entryEditTitleShort: "Edit Entry Orchestration",
  entryUpdateSuccess: "Entry orchestration updated",
  groupPrimary: "Main Section",
  groupTools: "Tools Section",
} as const;
